'use client';
import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  defs,
  linearGradient,
  stop,
} from 'recharts';

// Backend integration: replace with real-time utilization data from /api/fleet/utilization?range=12h
const data = [
  { time: '02:00', utilization: 31, deployed: 7 },
  { time: '04:00', utilization: 22, deployed: 5 },
  { time: '06:00', utilization: 45, deployed: 10 },
  { time: '07:00', utilization: 61, deployed: 14 },
  { time: '08:00', utilization: 74, deployed: 17 },
  { time: '09:00', utilization: 78, deployed: 18 },
  { time: '10:00', utilization: 83, deployed: 19 },
  { time: '11:00', utilization: 87, deployed: 20 },
  { time: '12:00', utilization: 80, deployed: 18 },
  { time: '13:00', utilization: 78, deployed: 18 },
  { time: '13:56', utilization: 78, deployed: 18 },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-900 border border-zinc-700 rounded-lg px-3 py-2.5 shadow-xl">
      <p className="text-xs font-semibold text-zinc-400 mb-1.5">{label}</p>
      <p className="text-sm font-bold text-amber-400">{payload[0]?.value}% utilization</p>
      <p className="text-xs text-zinc-500">{payload[1]?.value} assets deployed</p>
    </div>
  );
};

export default function FleetUtilizationChart() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-semibold text-zinc-200">Fleet Utilization — Today</h3>
          <p className="text-xs text-zinc-500 mt-0.5">% of active assets deployed over 12 hours</p>
        </div>
        <span className="text-xs text-zinc-500 font-mono">Updated 13:56</span>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <AreaChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: -20 }}>
          <defs>
            <linearGradient id="utilGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#F59E0B" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#F59E0B" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="deployGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#38BDF8" stopOpacity={0.2} />
              <stop offset="95%" stopColor="#38BDF8" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="rgb(39 39 42)" />
          <XAxis dataKey="time" tick={{ fontSize: 11, fill: 'rgb(113 113 122)', fontFamily: 'JetBrains Mono' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: 'rgb(113 113 122)' }} axisLine={false} tickLine={false} domain={[0, 100]} />
          <Tooltip content={<CustomTooltip />} />
          <Area type="monotone" dataKey="utilization" stroke="#F59E0B" strokeWidth={2} fill="url(#utilGrad)" dot={false} />
          <Area type="monotone" dataKey="deployed" stroke="#38BDF8" strokeWidth={1.5} fill="url(#deployGrad)" dot={false} />
        </AreaChart>
      </ResponsiveContainer>
      <div className="flex items-center gap-4 mt-3">
        <div className="flex items-center gap-1.5 text-xs text-zinc-500">
          <span className="w-3 h-0.5 bg-amber-400 inline-block rounded" />
          Utilization %
        </div>
        <div className="flex items-center gap-1.5 text-xs text-zinc-500">
          <span className="w-3 h-0.5 bg-sky-400 inline-block rounded" />
          Assets deployed
        </div>
      </div>
    </div>
  );
}